import { ConfigProvider, App as AntApp } from "antd";
import { reviTheme } from "../../../../../theme/reviTheme";
import { PageTherapistSesionInner } from "./PageTherapistSesionInner";
import "./Page_Therapist_Sesion.scss";

export function Page_Therapist_Sesion() {
  return (
    <ConfigProvider theme={reviTheme}>
      <AntApp>
        <PageTherapistSesionInner />
      </AntApp>
    </ConfigProvider>
  );
}
